<template>
	<div
		class="header-wrap"
		:style="`height: ${haveHeight ? navHeight : ''}px;`"
	>
		<div
			:class="
				'navbar custom-class ' + (status ? 'navbar-transparent' : '')
			"
			:style="`${url ? background : background_noUrl}`"
		>
			<!-- <div
				class="status-bar"
				:style="`height: ${statusBarHeight}px;`"
			></div> -->
			<div
				class="status-bar"
				:style="`height: 0.1rem;`"
			></div>

			<div class="navbar-action-wrap">
				<div
					:class="
						'navbar-action-group ' +
						(icon_status ? 'active_img' : '')
					"
				>
					<div class="title" v-if="is_index && title">
						{{ title }}
					</div>
					<div
						class="navbar_item_box"
						@click.stop.prevent="route"
						v-else-if="!is_index"
					>
						<img
							class="navbar_img"
							src="https://oss01.dayou.art/tresor-icon-back.png"
							mode="widthFix"
						/>
					</div>
				</div>

				<div v-if="!is_index && title" class="title title-left">
					{{ title }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { toapp } from "@/utils/utils";
export default {
	data() {
		return {
			icon_status: false,
			icon: '',
			background: '', //设置背景样式
			background_noUrl: 'background:black', //没有背景图时候的背景 默认黑色 如果传了status则透明
			is_index: true, // 是否为首页
		};
	},
	props: {
		title: {
			type: String,
		},
		status: {
			type: Boolean,
			default: false,
		},
		path: {
			type: String,
		},
		// 是否拥有高度
		haveHeight: {
			type: Boolean,
			default: true,
		},
		//背景图片
		url: {
			type: String,
			default: '',
		},
        // 自定义后退事件
        customEventRout: {
            type: Function,
        },
	},
    computed: {
        navHeight () {
            return this.$store.getters['page/get_navHeight']
        },
    },
	created() {
		this.init();
	},
	beforeMount() {
		//将背景设为传入url图片 若没图为纯黑色
        this.background = `background:url('${this.url}')`
		//判断status 如果为true 则头部为透明 否则为纯黑色
		if (this.status) {
			this.changeTansparents();
		}

		setTimeout(() => {
			this.init();
		}, 400);
	},
    mounted() {
        this.getQuery();
		if(this.$route.query.os&&!localStorage.getItem('os')){
			localStorage.setItem('os',this.$route.query.os)
		}
	},
	methods: {
		//将头部背景设为透明
		changeTansparents() {
            this.background_noUrl = `background:transparent`
		},
		//将头部背景设为黑色
		changeBlack() {
            this.background_noUrl = `background:black`
		},

		// 后退
		route() {
			if(this.$route.query.close){
				return toapp(1)
			}
            this.customEventRout
            ? this.customEventRout()
            : this.$router.go(-1)
		},

		init() {
			const current_route = this.$route; // 当前路由对象
			const path = current_route.path;
			const hideBackPath = [
				'/',
				'/pages/index/index',
				'/pages/house_box/house_box',
				'/pages/works_detail_h5/works_detail_h5',
			]; // 隐藏返回按钮的页面路径
            this.is_index = hideBackPath.includes(path)
		},


        // 获取路由参数
		getQuery() {
			const query = this.get_route_query(this.$route); // 路由参数对象
			// console.log(JSON.stringify(query));
			this.$store.commit('page/get_system_info', query.height);
			this.hanldeLogin(query);
		},
		// 获取路由参数对象
		get_route_query(route) {
			// 兼容hash模式
			if (route.fullPath.includes('/#/')) {
				let fullPath = route.fullPath;
				fullPath = fullPath.substring(fullPath.indexOf('?') + 1);
				const arr = fullPath.split('&');
				let query = {};
				for (let item of arr) {
					const [key, value] = item.split('=');
					query[key] = value;
				}
				return query;
			}
			return route.query;
		},

		// 登录
		hanldeLogin(query) {
			// console.log(query,"query")
			if (query.token) this.setToken(query.token);
		},

		// 设置token
		setToken(token) {
			localStorage.setItem('token', token);
			
			// console.log(`设置token成功：${token}`);
		},
	},
};
</script>

<style lang="less" scoped>
@import './header.less';
</style>
